import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetFiles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Asset_Files_svg__a)"
      fillOpacity={0.4}
      d="M3.333 14.198V5.622a.75.75 0 0 1 .75-.75h4.47a.75.75 0 0 1 .64.36l.998 1.639a.75.75 0 0 0 .64.36h5.086a.75.75 0 0 1 .75.75v6.217a.93.93 0 0 1-.93.93H4.263a.93.93 0 0 1-.93-.93"
      opacity={0.9}
    />
    <path
      fill="url(#Asset_Files_svg__b)"
      fillOpacity={0.3}
      d="M3.333 8.974V5.802a.93.93 0 0 1 .93-.93h4.189a.93.93 0 0 1 .794.446l.893 1.466a.93.93 0 0 0 .794.447h4.804a.93.93 0 0 1 .93.93v.813z"
    />
    <defs>
      <linearGradient
        id="Asset_Files_svg__a"
        x1={14.166}
        x2={-2.495}
        y1={12.404}
        y2={11.952}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Files_svg__b"
        x1={14.166}
        x2={-2.431}
        y1={7.884}
        y2={6.761}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetFiles;
